var map = {
	"./allianz-dark.png": "./src/assets/img/allianz-dark.png",
	"./allianz.png": "./src/assets/img/allianz.png",
	"./auto_gradient.png": "./src/assets/img/auto_gradient.png",
	"./banner-bckg-light.png": "./src/assets/img/banner-bckg-light.png",
	"./banner-bckg.png": "./src/assets/img/banner-bckg.png",
	"./captcha_dummy.png": "./src/assets/img/captcha_dummy.png",
	"./captcha_dummy_empty.png": "./src/assets/img/captcha_dummy_empty.png",
	"./check-active.png": "./src/assets/img/check-active.png",
	"./check-empty.png": "./src/assets/img/check-empty.png",
	"./colonnade-dark.png": "./src/assets/img/colonnade-dark.png",
	"./colonnade.png": "./src/assets/img/colonnade.png",
	"./defend.png": "./src/assets/img/defend.png",
	"./generali-dark.png": "./src/assets/img/generali-dark.png",
	"./generali.png": "./src/assets/img/generali.png",
	"./graf.png": "./src/assets/img/graf.png",
	"./komunalna-dark.png": "./src/assets/img/komunalna-dark.png",
	"./komunalna.png": "./src/assets/img/komunalna.png",
	"./kooperativa-dark.png": "./src/assets/img/kooperativa-dark.png",
	"./kooperativa.png": "./src/assets/img/kooperativa.png",
	"./logo-tl-dark.svg": "./src/assets/img/logo-tl-dark.svg",
	"./logo-tl-light.svg": "./src/assets/img/logo-tl-light.svg",
	"./logo-tl-mobil-dark.svg": "./src/assets/img/logo-tl-mobil-dark.svg",
	"./logo-tl-mobil-light.svg": "./src/assets/img/logo-tl-mobil-light.svg",
	"./logo-tl.png": "./src/assets/img/logo-tl.png",
	"./no_image.png": "./src/assets/img/no_image.png",
	"./op_female.png": "./src/assets/img/op_female.png",
	"./op_male.png": "./src/assets/img/op_male.png",
	"./refresh.svg": "./src/assets/img/refresh.svg",
	"./table-sort-asc-light.svg": "./src/assets/img/table-sort-asc-light.svg",
	"./table-sort-asc.svg": "./src/assets/img/table-sort-asc.svg",
	"./table-sort-desc-light.svg": "./src/assets/img/table-sort-desc-light.svg",
	"./table-sort-desc.svg": "./src/assets/img/table-sort-desc.svg",
	"./table-sort-light.svg": "./src/assets/img/table-sort-light.svg",
	"./table-sort.svg": "./src/assets/img/table-sort.svg",
	"./union-dark.png": "./src/assets/img/union-dark.png",
	"./union.png": "./src/assets/img/union.png",
	"./uniqa-dark.png": "./src/assets/img/uniqa-dark.png",
	"./uniqa.png": "./src/assets/img/uniqa.png",
	"./znacka.jpg": "./src/assets/img/znacka.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*$";